import { render, staticRenderFns } from "./PricePackageDetail.vue?vue&type=template&id=ee4c65f6"
import script from "./PricePackageDetail.vue?vue&type=script&lang=js"
export * from "./PricePackageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports